import React from 'react';
import { useDarkMode } from '../components/DarkMode';
import { FaGithub, FaLinkedin} from 'react-icons/fa';

const Contact = () => {
    const { isDarkMode } = useDarkMode();

    return (
        <div id="Contact" className="container mx-auto px-4 py-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className={`${isDarkMode ? 'bg-neutral-800 text-white' : 'border border-black'} text-center rounded-lg p-4`}>
                    <div>
                        <h2 className="text-3xl font-bold mb-4">Links</h2>
                        <ul className="space-y-4 text-lg">
                            <li className='py-2'>
                                <a href="https://github.com/ChrstnAnsl/" target="_blank" rel="noopener noreferrer" className="flex sm:justify-start hover:text-blue-900">
                                    <FaGithub className="mr-2 sm:mr-5" />
                                    <span>https://github.com/ChrstnAnsl/</span>
                                </a>
                            </li>
                            <li className='py-2'>
                                <a href="https://www.linkedin.com/in/christian-ansel/" target="_blank" rel="noopener noreferrer" className="flex sm:justify-start hover:text-blue-900">
                                    <FaLinkedin className="mr-2 sm:mr-5" />
                                    <span>https://www.linkedin.com/in/christian-ansel/</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className={`${isDarkMode ? 'bg-neutral-800 text-white' : 'border border-black'}  rounded-lg p-4`}>
                    <div className="text-2xl font-bold mb-4 text-center">
                        <h2> Location </h2>
                    </div>
                    <div>
                        <p className='mb-4'> I am currently residing in the Philippines. </p>
                        <iframe
                            src="https://www.google.com/maps/d/embed?mid=1l4Clf7zV6PiFP7rAK0ML9Em8vTg&hl=en"
                            width="100%"
                            height="400"
                            frameBorder="0"
                            allowFullScreen=""
                            aria-hidden="false"
                            tabIndex="0"
                            title="Google Map"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
